<div
  class="footer-notification flex flex-row items-start justify-center"
  [class.footer-notification--compact]="compact"
  data-test="footerNotification">
  <div class="footer-notification__wrapper">
    <!-- title -->
    <div
      class="footer-notification__title text-16 html"
      [innerHTML]="label | markdown"
      data-test="footerNotificationTitle"></div>

    <!-- action -->
    <button
      *ngIf="buttonLabel"
      app-button
      buttonType="primary"
      (click)="handleActionClick()"
      data-test="footerNotificationAction">
      {{ buttonLabel }}
    </button>
  </div>

  <!-- dismiss -->
  <button
    class="footer-notification__close"
    app-button
    buttonType="default"
    buttonTheme="light"
    type="button"
    (click)="handleDismissClick()"
    title="Close"
    [attr.aria-label]="'Close'"
    data-test="footerNotificationDismiss">
    <app-icon icon="times" size="lg"></app-icon>
  </button>
</div>
